import React from "react";
//@ts-ignore
import { ModalAcceptCancel } from "@viuti/recursos";

//@ts-ignore
import style from "./ScheduleImpactModal.module.css";

import { IAffectedReservation } from "../../../../services/getScheduleImpact.service";
import { exportAffectedReservations } from "../../../../utilities/exportAffectedReservations";

interface ScheduleImpactModalProps {
  visible: boolean;
  setVisible: (value: boolean) => void;
  affected: IAffectedReservation[];
  employeeName?: string;
  onConfirm: () => void;
  isLoading?: boolean;
  /** Texto del botón de confirmación (por defecto "Confirmar"). */
  confirmText?: string;
}

const ScheduleImpactModal: React.FC<ScheduleImpactModalProps> = ({
  visible,
  setVisible,
  affected,
  employeeName,
  onConfirm,
  isLoading = false,
  confirmText = "Confirmar",
}) => {
  if (!visible) return null;

  const count = affected.length;
  // En la carga masiva cada cita indica su estilista.
  const showEmployee = affected.some((r) => !!r.employeeName);

  const handleDownload = () => {
    exportAffectedReservations(affected, employeeName);
  };

  return (
    <ModalAcceptCancel
      title={"Impacto del cambio de horario"}
      visibility={{
        isVisible: visible,
        setIsVisible: setVisible,
      }}
      showButtons={{
        showButtonOne: true,
        showButtonTwo: true,
        showButtonClose: true,
      }}
      actionButtonClose={() => setVisible(false)}
      buttonOne={{
        textButtonOne: "Cancelar",
        actionButtonOne: () => setVisible(false),
        isDisabled: isLoading,
      }}
      buttonTwo={{
        textButtonTwo: confirmText,
        actionButtonTwo: onConfirm,
        isLoading: isLoading,
      }}
    >
      <div className={style.container}>
        <p className={style.notice}>
          Este cambio de horario afectará <strong>{count}</strong>{" "}
          {count === 1 ? "reserva" : "reservas"}
          {employeeName ? ` de ${employeeName}` : ""}. Al confirmar, esas
          reservas pasarán a <strong>"Por asignar"</strong> (sin estilista) y
          deberás reasignarlas manualmente.
        </p>

        <div className={style.toolbar}>
          <button
            type="button"
            className={style.downloadBtn}
            onClick={handleDownload}
            disabled={count === 0}
          >
            Descargar Excel
          </button>
        </div>

        <div className={style.tableWrapper}>
          <table className={style.table}>
            <thead>
              <tr>
                {showEmployee && <th>Estilista</th>}
                <th>Cliente</th>
                <th>Servicio</th>
                <th>Fecha/Hora</th>
                <th>Sede</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {affected.map((r) => (
                <tr key={r.reservationDetailId}>
                  {showEmployee && <td>{r.employeeName || "—"}</td>}
                  <td>{r.clientName}</td>
                  <td>{(r.services || []).join(", ")}</td>
                  <td>{r.dateTime}</td>
                  <td>{r.localName ?? "—"}</td>
                  <td>
                    <span className={style.statusBadge}>{r.status}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </ModalAcceptCancel>
  );
};

export default ScheduleImpactModal;
